var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageBox"},[_c('PageComponent',{attrs:{"publicTemplateName":"未访问H5页面","publicStatus":1200}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }